/*
 * Junip reviews, photos first
 *
 * Junip has no setting for a default filter, so this ticks its "Photos & videos" checkbox
 * each time the product reviews list loads, on every `[data-plug-junip-media-first]`
 * wrapper (sections/plug-reviews.liquid, sections/apps.liquid). The wrapper renders with
 * `plug-junip--media-pending`, which keeps the list hidden until the photo reviews land
 * (see assets/junip-plug.css). Once a customer clears the filter it stays cleared.
 * Products without photo reviews: Junip keeps the filter on and shows every review under
 * a "No reviews match" note, so the filter is reset quietly and the list shown right away.
 */
(function () {
  var PENDING = "plug-junip--media-pending";
  var OPENING = "plug-junip--media-opening";
  var SELECTOR = 'input[name="junipMediaFilter"]';

  // This script's own clicks are not the customer's, so keep them out of PostHog autocapture
  // (about 90k clicks and rage clicks a day). PostHog reads the class during the click.
  function quietClick(el) {
    var had = el.classList.contains("ph-no-capture");
    el.classList.add("ph-no-capture");
    try {
      el.click();
    } finally {
      if (!had) el.classList.remove("ph-no-capture");
    }
  }

  function init(app) {
    var want = true;
    var userCleared = false;
    var noMedia = false;
    var autoTicked = false;
    var openedPanel = false;
    var tabSwitchAt = 0;
    var sawBusy = false;
    var failsafe;
    var hiddenAt = 0;
    var settleTimer;

    function hide() {
      app.classList.add(PENDING);
      clearTimeout(failsafe);
      hiddenAt = 0;
    }

    function reveal() {
      clearTimeout(failsafe);
      app.classList.remove(PENDING, OPENING);
    }

    // Junip lists the product reviews tab first. The media filter only exists there.
    // Product pages have no tabs.
    function productTab() {
      var tab = app.querySelector('[role="tab"]');
      return tab ? tab.getAttribute("aria-selected") === "true" : true;
    }

    // Junip shows a spinner while a tab loads and a "Loading..." row while the list fetches.
    function busy() {
      return !!app.querySelector(
        ".junip-content-loading:not(.junip-loading-spinner-hide), .junip-reviews-container > .junip-loader:not(.junip-fade-out)"
      );
    }

    // The filtered list has landed once every review card carries media.
    function listShowsMedia() {
      var cards = app.querySelectorAll(".junip-reviews-container > :not(.junip-loader)");
      if (!cards.length) return false;
      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].querySelector(".junip-review-media-container")) return false;
      }
      return true;
    }

    // No photo reviews: Junip keeps the filter on and shows the full list under a "No reviews
    // match these filters" note. The "Reset filters" link shows for any active filter, so key
    // on the note next to it. Only undo a filter this script set.
    function dropEmptyFilter() {
      if (!autoTicked || noMedia || want || busy() || listShowsMedia()) return false;
      var note = app.querySelector(".junip-filters-text > :not(.junip-reset)");
      var reset = app.querySelector(".junip-filters-text .junip-reset");
      if (!note || !reset || !note.textContent.trim()) return false;
      noMedia = true;
      autoTicked = false;
      quietClick(reset);
      reveal();
      return true;
    }

    function track() {
      if (tabSwitchAt && busy()) sawBusy = true;
      if (
        !openedPanel &&
        app.classList.contains(OPENING) &&
        !app.querySelector('.junip-filters-toggle[aria-expanded="true"]')
      ) {
        app.classList.remove(OPENING);
      }
      if (dropEmptyFilter()) return;
      if (!app.classList.contains(PENDING)) return;
      if (userCleared || noMedia || (!want && (listShowsMedia() || !productTab()))) return reveal();
      if (!app.querySelector(".junip-reviews-container")) return;
      // Failsafe if the filtered list never lands: show the list after 4s of Junip sitting
      // idle, and never keep it hidden more than 10s once Junip has drawn it.
      if (!hiddenAt) hiddenAt = Date.now();
      var left = Math.max(0, 10000 - (Date.now() - hiddenAt));
      clearTimeout(failsafe);
      failsafe = setTimeout(reveal, busy() ? left : Math.min(4000, left));
    }

    // Junip resets the filter each time the product reviews tab loads and ignores changes until
    // that load is done, which can start a moment after the tab click. So wait for the load to
    // come and go (or 3s), then tick the filter. On small screens the filter panel is collapsed
    // and the checkbox isn't rendered, so open the panel first and close it again after.
    function settle() {
      if (!want || userCleared || noMedia || !productTab()) return;
      if (busy() || (tabSwitchAt && !sawBusy && Date.now() - tabSwitchAt < 3000)) return schedule();
      var input = app.querySelector(SELECTOR);
      if (!input) {
        var toggle = app.querySelector('.junip-filters-toggle[aria-expanded="false"]');
        if (toggle && !openedPanel) {
          openedPanel = true;
          app.classList.add(OPENING);
          quietClick(toggle);
        }
        return;
      }
      want = false;
      tabSwitchAt = 0;
      if (!input.checked) {
        hide();
        autoTicked = true;
        quietClick(input);
      }
      if (openedPanel) {
        openedPanel = false;
        var open = app.querySelector('.junip-filters-toggle[aria-expanded="true"]');
        if (open) quietClick(open);
      }
      track();
    }

    function schedule() {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 400);
    }

    // Junip toggles the (read-only) checkbox from its wrapper and never fires `change`, so
    // catch the customer's own click or key press before Junip handles it.
    function onInput(event) {
      if (!event.target.closest) return;
      if (event.type === "keydown" && event.key !== "Enter" && event.key !== " ") return;
      var tab = event.target.closest('[role="tab"]');
      if (tab) {
        if (tab.getAttribute("aria-selected") === "true") return;
        tabSwitchAt = Date.now();
        sawBusy = false;
        want = !userCleared && !noMedia && tab === app.querySelector('[role="tab"]');
        if (want) hide();
        return;
      }
      if (!event.isTrusted) return;
      var box = event.target.closest(".junip-checkbox");
      var input = box && box.querySelector(SELECTOR);
      if (box) autoTicked = false;
      if ((input && input.checked) || event.target.closest(".junip-reset")) userCleared = true;
    }
    app.addEventListener("click", onInput, true);
    app.addEventListener("keydown", onInput, true);

    hide();
    schedule();
    new MutationObserver(function () {
      track();
      schedule();
    }).observe(app, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "aria-selected", "aria-expanded"],
    });
  }

  function boot() {
    var apps = document.querySelectorAll("[data-plug-junip-media-first]");
    for (var i = 0; i < apps.length; i++) {
      if (apps[i].hasAttribute("data-plug-junip-media-first-bound")) continue;
      apps[i].setAttribute("data-plug-junip-media-first-bound", "");
      init(apps[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
